<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
 */

defineProps<{
    num: number
    icon: string
    text: string
    isFinalStep?: boolean
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
</script>

<template>
    <div class="tw-flex tw-flex-col">
        <h3
            class="tw-text-primary !tw-font-semibold tw-text-[28px] tw-leading-[42px]"
        >
            {{ num <= 9 ? `0${num}` : num }}
        </h3>
        <div
            class="tw-p-3 tw-bg-secondary tw-w-max tw-h-max tw-rounded-full tw-mx-[27px] tw-aspect-[1/1]"
        >
            <div
                class="steps-container tw-w-[80px] tw-aspect-[1/1] tw-bg-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-relative"
            >
                <q-icon :name="icon" size="35px" class="tw-text-primary" />
                <div v-if="!isFinalStep" class="steps-indicator"></div>
            </div>
        </div>
        <h6
            class="tw-mt-[25px] tw-mx-auto tw-w-[136px] tw-text-center tw-text-primary !tw-font-semibold tw-leading-6"
        >
            {{ text }}
        </h6>
    </div>
</template>

<style>
.steps-container {
    box-shadow: 0px 4px 4px 0px #00000040;
}
.steps-indicator {
    @apply tw-w-[140px] tw-h-[3px] tw-bg-primary tw-my-auto tw-absolute tw-bottom-0 tw-top-0 tw-right-0 tw-translate-x-[100%];
}

.steps-indicator::after {
    content: "";
    @apply tw-w-4 tw-h-4 tw-rounded-full tw-absolute tw-right-0 tw-top-0 tw-bottom-0 tw-my-auto tw-bg-primary;
}
</style>
